var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ake_header"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('div',[(_vm.showClose)?_c('el-tooltip',{attrs:{"content":"关闭","placement":"top"}},[_c('AkeIcon',{attrs:{"name":"icon_close|svg","size":"24"},on:{"click":_vm.closeModal}})],1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }